<template>
  <div>
    <template v-for="(section, key) in sections">
      <div v-if="section.type !== 'FaqSection'" :key="key" class="blogSingle__section">
        <component
          :data="section.data"
          :is="`editor-${$helper.kebabCase(section.type)}`"
          :items="section.items"
        />
      </div>
      <div v-else :key="key" class="blogSingle__faq">
        <div
          :key="`faq-${index}`"
          v-for="(faqSection, index) in faqSections"
          class="blogSingle__section"
        >
          <component
            :data="faqSection.data"
            :is="`editor-${$helper.kebabCase(faqSection.type)}`"
            :items="faqSection.items"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import EditorBlogHeader from '~/components/Editor/Blog/EditorBlogHeader';
import EditorBlogParagraph from '~/components/Editor/Blog/EditorBlogParagraph';
import EditorBlogList from '~/components/Editor/Blog/EditorBlogList';
import EditorBlogProductsSection from '~/components/Editor/Blog/EditorBlogProductsSection';
import EditorBlogSelectedProductsSection from '~/components/Editor/Blog/EditorBlogSelectedProductsSection';
import EditorBlogImage from '~/components/Editor/Blog/EditorBlogImage';
import EditorBlogTable from '~/components/Editor/Blog/EditorBlogTable';
import EditorBlogEmbed from '~/components/Editor/Blog/EditorBlogEmbed';
import EditorBlogColumnsTextImage from '~/components/Editor/Blog/EditorBlogColumnsTextImage';
import EditorCodeTool from '~/components/Editor/EditorCodeTool';

export default {
  name: 'BlogSections',
  components: {
    'editor-header': EditorBlogHeader,
    'editor-paragraph': EditorBlogParagraph,
    'editor-list': EditorBlogList,
    'editor-products-section': EditorBlogProductsSection,
    'editor-selected-products-section': EditorBlogSelectedProductsSection,
    'editor-image': EditorBlogImage,
    'editor-table': EditorBlogTable,
    'editor-embed': EditorBlogEmbed,
    'editor-code-tool': EditorCodeTool,
    'editor-columns-text-image': EditorBlogColumnsTextImage,
  },
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      faqSections: [],
    };
  },
  mounted() {
    const faqSectionData = this.sections.find(item => item.type === 'FaqSection');

    if (typeof faqSectionData !== 'undefined') {
      const sections = [];
      sections.push({
        type: 'header',
        data: {
          level: 2,
          text: faqSectionData[0].data.heading,
        },
      });
      sections.push(...(faqSectionData[0].data.blocks.blocks ?? []));
      this.faqSections = sections;
    }
  },
};
</script>

<style scoped></style>
